export const normalizeAddedTo = addedTo => {
  const existAddedTo = Array.isArray(addedTo) && addedTo?.length;

  if (!existAddedTo) {
    return null;
  }

  return addedTo.map(label_parent => label_parent.value);
};
